import { createReducer, on } from '@ngrx/store';
import { initialState, MapState } from './map-state';
import { MapActions } from './map-actions';

export const mapReducer = createReducer(initialState,
    on(MapActions.toggleCvButton, (state): MapState => ({
      ...state,
      cvButtonActive: !state.cvButtonActive,
      // toggle street view as well whenever validate button is on
      streetViewActive: !state.cvButtonActive,
    })),
    on(MapActions.toggleMarkersMinimizedButton, (state): MapState => ({
      ...state,
      markersMinimized: !state.markersMinimized,
    })),
    on(MapActions.updateStreetViewActive, (state, { streetViewActive }): MapState => ({
      ...state,
      streetViewActive,
    })),
    on(MapActions.updateStreetViewClosedByUser, (state, { streetViewClosedByUser }): MapState => ({
      ...state,
      streetViewClosedByUser,
    })),
    on(MapActions.updateShowValidationHistory, (state, { showValidationHistory }): MapState => ({
      ...state,
      showValidationHistory,
    })),
);
